import { DeleteForever, Edit } from "@mui/icons-material";
import ConfirmationDialog from "../../../shared/ConfirmationDialog";
import { useState } from "react";
import { Button } from "@mui/material";

const VariantImageCard = ({ item, setEditImageId, handleDelete, setState }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="card rounded-ls shadow-xl !bg-base-100 cursor-pointer relative h-60 !mb-4"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img alt="" src={item?.variant_image} className="h-48 w-80" />
      {isHovered && (
        <div className="absolute bottom-0 left-0 w-full flex-row py-1 bg-gray-300 bg-opacity-40 !rounded-b-lg card-body flex justify-center card-actions">
          <Button
            className="!min-w-fit"
            onClick={() => {
              setEditImageId(item.id);
              setState((prev) => prev + 1);
            }}
          >
            <Edit className="text-green-500 cursor-pointer" />
          </Button>
          <ConfirmationDialog
            title="Are you sure you want to delete this variant?"
            description="This will permanently remove the selected image variant from the database."
            onConfirm={() => handleDelete(item.id)}
          >
            <DeleteForever className="text-red-500 cursor-pointer" />
          </ConfirmationDialog>
        </div>
      )}
    </div>
  );
};

export default VariantImageCard;
